/**
 * Config Selectors
 *
 * Memoized selectors for accessing onboarding config state.
 * Using createSelector ensures components only re-render when selected data changes.
 */
import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/store';

// ============================================
// Base Selectors
// ============================================

const selectConfigState = (state: RootState) => state.onboarding.config;

// ============================================
// Config Selectors (Memoized)
// ============================================

export const selectOnboardingConfig = createSelector(
  [selectConfigState],
  (config) => config.config,
);

export const selectOnboardingConfigLoading = createSelector(
  [selectConfigState],
  (config) => config.isLoading,
);

export const selectOnboardingConfigError = createSelector(
  [selectConfigState],
  (config) => config.error,
);
